import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { UploadStatusProvider } from './contexts/UploadStatusContext';
import AppLayout from './components/AppLayout';
import Login from './components/Login';
import MultiDashboard from './components/MultiDashboard';
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import BuyCredits from "./components/BuyCredits";
import LazyCheckout from "./components/LazyCheckout";
import Landing from "./components/Landing";
import PreOrderPage from "./components/PreOrderPage";
import AboutUsPage from "./components/AboutUsPage";
import PhilosophyPage from "./components/PhilosophyPage";
import TrackSimulation from "./components/TrackSimulation";
import VideoCompare from './components/VideoCompare';
import VideoSyncTest from './components/VideoSyncTest';
import PrivateRoute from './components/PrivateRoute';
import AdminPage from "./components/AdminPage";
import LiveSessionTestPage from "./components/LiveSessionTestPage";
import LiveRunsPage from "./components/LiveRunsPage";

// New Pages
import Home from './components/Home';
import MyRides from './components/MyRides';
import RideView from './components/RideView';
import Compare from './components/Compare';
import Help from './components/Help';
import Profile from './components/Profile';
import Settins from './components/Settins';
import BikeOnboardingPage from './components/BikeOnboardingPage';
import TuningGuidePage from './components/TuningGuidePage';
import OAuthCallback from './components/OAuthCallback';
import PublicGroupPage from './components/PublicGroupPage';
import Calendar from './components/Calendar';
import Support from './components/Support';

function App() {
  return (
    <AuthProvider>
      <SidebarProvider>
        <UploadStatusProvider>
          <BrowserRouter>
            <AppLayout>
            <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/pre-order" element={<PreOrderPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/philosophy" element={<PhilosophyPage />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/bike-onboarding"
              element={
                <PrivateRoute>
                  <BikeOnboardingPage />
                </PrivateRoute>
              }
            />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/tos" element={<TermsOfService />} />
            <Route path="/support" element={<Support />} />
            <Route
              path="/checkout"
              element={
                <Suspense fallback={null}>
                  <LazyCheckout />
                </Suspense>
              }
            />
            <Route path="/homepage" element={<Navigate to="/home" replace />} />
            
            {/* Protected Routes - New Layout */}
            <Route
              path="/buy-credits"
              element={
                <PrivateRoute>
                  <BuyCredits />
                </PrivateRoute>
              }
            />
            <Route
              path="/home"
              element={<Home />}
            />
            <Route
              path="/tuning-guide"
              element={
                <PrivateRoute>
                  <TuningGuidePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/my-rides"
              element={
                <PrivateRoute>
                  <MyRides />
                </PrivateRoute>
              }
            />
            <Route
              path="/calendar"
              element={
                <PrivateRoute>
                  <Calendar />
                </PrivateRoute>
              }
            />
            <Route
              path="/ride/:rideId"
              element={<RideView />}
            />
            <Route
              path="/compare"
              element={
                <PrivateRoute>
                  <Compare />
                </PrivateRoute>
              }
            />
            <Route
              path="/help"
              element={
                <PrivateRoute>
                  <Help />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route path="/settins" element={<Navigate to="/settings" replace />} />
            <Route
              path="/settings"
              element={
                <PrivateRoute>
                  <Settins />
                </PrivateRoute>
              }
            />
            <Route
              path="/oauth/callback"
              element={
                <PrivateRoute>
                  <OAuthCallback />
                </PrivateRoute>
              }
            />

            {/* Public: shared group page */}
            <Route path="/g/:publicId" element={<PublicGroupPage />} />

            {/* Legacy Routes - Keep for backward compatibility */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <MultiDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/live"
              element={
                <PrivateRoute>
                  <LiveRunsPage />
                </PrivateRoute>
              }
            />
            <Route path="/multi-dashboard" element={<MultiDashboard />} />
            
            <Route
              path="/video-compare"
              element={
                <PrivateRoute>
                  <VideoCompare />
                </PrivateRoute>
              }
            />
            
            {/* Development/Testing Routes */}
            <Route path="/video-sync-test" element={<VideoSyncTest />} />
            <Route path="/live-session-test" element={<LiveSessionTestPage />} />
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminPage />
                </PrivateRoute>
              }
            />
            <Route path="/track-simulation" element={<TrackSimulation />} />
            </Routes>
          </AppLayout>
        </BrowserRouter>
        </UploadStatusProvider>
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;